import styles from "./index.module.css";
import t1 from "./1.jpg";
import t2 from "./2.jpg";
import t3 from "./3.jpg";
import t4 from "./4.jpg";
import t5 from "./5.jpg";
import t6 from "./6.jpg";
import t7 from "./7.jpg";
import t8 from "./8.jpg";
import t9 from "./9.jpg";
import t10 from "./10.jpg";
import t11 from "./11(2).jpg";
import t12 from "./12.jpg";
import t13 from "./13.jpg";
import t14 from "./14.jpg";

export default function NewTeachersBlock() {
  const images1 = [t1, t2, t3, t4, t5, t6, t7, t8, t9];
  const images2 = [t6, t7, t8, t9, t10, t11, t12, t13, t14];

  return (
    <div className={styles.container} id={"teachers"} data-aos={"fade-up"}>
      <div className={styles.bcontainer}>
        <div className={styles.descriptionBlock}>
          <h2>Хто викладає?</h2>
          <h3>Спеціалісти Profound</h3>
          <div className={styles.tagsBlock}>
            <span className={styles.experienced}>досвідчені</span>
            ,{" "}
            <span className={styles.certified}>дипломовані</span>,{" "}
            <br /> мають{" "}
            <span className={styles.international}>
              міжнародні сертифікати
            </span>{" "}
            та <br />
            <span className={styles.reviews}>схвальні відгуки</span>{" "}
            своїх учнів
          </div>
        </div>

        <div className={styles.left}>
          <div className={styles.rotation + " " + styles.spin}>
            {images1.map((img, i) => {
              const angle = (360 / images1.length) * i;

              return (
                <div
                  key={i}
                  className={styles.item}
                  style={{
                    "--angle": `${angle}deg`,
                    "--radius": "292px",
                  }}
                >
                  <div className={styles.imgWrapper + " " + styles.counterSpin}>
                    <img src={img} alt="" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.rotation + " " + styles.counterSpin}>
            {images1.map((img, i) => {
              const angle = (360 / images2.length) * i;

              return (
                <div
                  key={i}
                  className={styles.item}
                  style={{
                    "--angle": `${angle}deg`,
                    "--radius": window.innerWidth > 900 ? "292px" : "240px",
                  }}
                >
                  <div className={styles.imgWrapper + " " + styles.spin}>
                    <img src={img} alt="" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
